import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ToolCard from '../common/ToolCard';
import toolsConfig from '../../config/tools';

/**
 * Tools Section for Homepage
 * Displays cards for available tools
 */
const ToolsSection = () => {
  // Convert tools config to array for rendering
  const tools = Object.values(toolsConfig.tools).map(tool => ({
    title: tool.title,
    description: tool.shortDescription,
    path: tool.path,
    tech: tool.tech
  }));

  return (
    <>
      <h2 style={{
        fontSize: '2rem',
        fontWeight: '300',
        color: '#2d3748',
        textAlign: 'center',
        marginBottom: '1rem',
        fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
      }}>
        Tools
      </h2>
      <p style={{
        fontSize: '1rem',
        color: '#718096',
        textAlign: 'center',
        marginBottom: '2rem',
        lineHeight: '1.6',
        fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
      }}>
        {toolsConfig.landing.subtitle}
      </p>
      <Row className="g-4 justify-content-start">
        {tools.map((tool, index) => (
          <Col md={6} lg={4} key={index}>
            <ToolCard tool={tool} />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ToolsSection;
